import { RootState, store } from 'src/Common/RTK/store';
import { scopeOfFeatures } from './FeatureList';
import { access, overAllAccess } from './utils';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { TenantProvider } from 'src/tenantConfig/interface';

export interface TenantAccessLevel {
  editAccess: boolean;
  accessLevel: string[];
}

export const updateTenantFeatures = (tenant: string, scopes: string[]): TenantAccessLevel => {
  const tenantAccess: TenantAccessLevel = {
    editAccess: false,
    accessLevel: [],
  };
  const hirerachy: string[] = [];

  //map the scopes with access level
  scopes.forEach((scope) => {
    overAllAccess.find((limit, index) => {
      if (limit.includes(scope) && index === 0) {
        tenantAccess.accessLevel = scopeOfFeatures[tenant][access.ADMIN];
        tenantAccess.editAccess = true;
        hirerachy.push(access.ADMIN);
        // return access.ADMIN;
      } else if (limit.includes(scope) && index === 1) {
        tenantAccess.accessLevel = scopeOfFeatures[tenant][access.EDIT];
        tenantAccess.editAccess = true;
        hirerachy.push(access.EDIT);
        // return access.EDIT;
      } else if (limit.includes(scope) && index === 2) {
        tenantAccess.accessLevel = scopeOfFeatures[tenant][access.VIEW];
        tenantAccess.editAccess = false;
        hirerachy.push(access.VIEW);
        // return access.VIEW;
      }
      return false; // Ensure all code paths return a value
    });
  });

  //check for the highest access level
  if (hirerachy.includes(access.ADMIN)) {
    tenantAccess.accessLevel = scopeOfFeatures[tenant][access.ADMIN] || [];
    tenantAccess.editAccess = true;
  } else if (hirerachy.includes(access.EDIT)) {
    tenantAccess.accessLevel = scopeOfFeatures[tenant][access.EDIT] || [];
    tenantAccess.editAccess = true;
  } else if (hirerachy.includes(access.VIEW)) {
    tenantAccess.accessLevel = scopeOfFeatures[tenant][access.VIEW] || [];
    tenantAccess.editAccess = false;
  }

  return tenantAccess;
};

export const isFeatureAvailableForTenant = (_feature: string): boolean => {
  //roleList is the list of roles that the user has
  const storeState = store.getState() as RootState;

  //latest tenant mapping
  const rbacFeatures = storeState?.manageActionData?.rbacFeatures;

  if (rbacFeatures?.length > 0) {
    return rbacFeatures.includes(_feature);
  }

  return false;
};

export const isUserAccessValid = (
  loggedInUser: string,
  workItem: any,
  configData: any
): boolean => {
  const requestorsList =
    configData?.provider === TenantProvider.ADO
      ? workItem.Fields[UATConstants.UATFields.Requestors]?.split(
          UATConstants.PlaceholdersAndTitles.SemiColon
        )
      : workItem?.fields?.requestorsinfo?.[0];
  const validRequestor =
    configData?.provider === TenantProvider.ADO
      ? requestorsList?.includes(loggedInUser)
      : requestorsList?.uniquename === loggedInUser;
  if (validRequestor) {
    return true;
  }
  return false;
};
